// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Design tokens del rediseño V2 de Dylo.
 *
 * - La PALETA DE MARCA (teal/azul/naranja) y las medidas (radios, fuente)
 *   son constantes: no cambian entre temas.
 * - Los TOKENS SEMÁNTICOS (superficies, texto, campos, sombras) se resuelven
 *   por tema mediante el atributo \`data-theme\` en <html>:
 *     · Sin atributo  -> sigue el tema del SISTEMA (prefers-color-scheme). [default]
 *     · data-theme="light" / "dark" -> fuerza el tema elegido por el usuario.
 *
 * El ThemeProvider de V2 gestiona el atributo y la persistencia.
 */

:root {
  /* ---- Marca — teal ---- */
  --dylo-teal-900: #00827e;
  --dylo-teal-700: #008984;
  --dylo-teal-500: #18a29c;
  --dylo-teal-300: #33bdb7;

  /* ---- Marca — azul ---- */
  --dylo-blue-700: #005da0;
  --dylo-blue-500: #009ce0;
  --dylo-blue-300: #67c9f2;

  /* ---- Acento — naranja (botón primario) ---- */
  --dylo-orange: #f7941e;
  --dylo-orange-hover: #e88510;
  --dylo-orange-active: #d97a08;

  /* ---- Éxito — verde de cierre ----
     Mismo verde que ya usa el estatus "Delivered" en los catálogos de estatus
     (\`statusCatalogs.ts\`), para que un embarque cerrado se lea igual en la tabla,
     en la barra de avance y en el recorrido. */
  --dylo-success: #22a04a;

  /* ---- Radios ---- */
  --radius-card: 24px;
  --radius-control: 12px;
  --radius-sm: 8px;

  /* ---- Sombra de controles ---- */
  --shadow-control: 0 1px 2px rgba(16, 24, 40, 0.05);

  /* ---- Tipografía ---- */
  --font-sans: 'Poppins', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;

  /* ===== Semánticos — LIGHT (default) ===== */
  --dylo-page-bg: #f4f6f8;
  --dylo-login-bg: #2b2b2b;
  --dylo-surface: #ffffff;
  --dylo-surface-border: #dce0e6;
  --dylo-ink: #222222;
  --dylo-text: #3a3f45;
  --dylo-muted: #8a8f98;
  --dylo-line: #e4e7ec;
  --dylo-field-bg: #ffffff;
  --dylo-field-border: #e2e5ea;
  --dylo-field-icon: #9aa0a8;
  --dylo-footer: rgba(255, 255, 255, 0.6);
  --dylo-danger: #e5484d;
  --dylo-danger-bg: #fdecec;
  --shadow-card: 0 4px 16px rgba(0, 0, 0, 0.08);

  /* Borde del sidebar (naranja en dark) */
  --dylo-sidebar-border: var(--dylo-surface-border);
  /* Grosor de borde de las cards (más grueso en dark) */
  --dylo-card-border-width: 1.5px;
  /* Color del chevron del botón de colapsar (blanco en light, ámbar en dark) */
  --dylo-collapse-icon: #ffffff;
  /* Card "spotlight" (Client Analysis): oscura en light, superficie normal en dark */
  --dylo-spotlight-bg: #111214;
  --dylo-spotlight-border: #1e1f22;
  --dylo-spotlight-text: #e9eaec;

  /*
    🔴 15-oct-2026: tokens que varios módulos usaban SIN que existieran. Un \`var()\` sin respaldo que apunta a un
    token inexistente no falla: el navegador descarta la declaración y el texto hereda el color de su padre. Así
    salía "Assigned" en negro en la campanita, y las tarjetas de la bandeja no tenían borde ni barra de acento.
    \`styles/tokens.test.ts\` falla si vuelve a pasar.
  */
  /* Advertencia: ámbar. Más oscuro en claro, para que el texto sobre su tinte se lea (contraste 4.5:1). */
  --dylo-warning: #b45309;
  /* Superficie secundaria: pastillas neutras, etiquetas de modalidad, botones de filtro. */
  --dylo-surface-2: #f1f3f6;
  /* Cuánto del color de un estatus o un área entra en su texto; el resto es tinta del tema. */
  --dylo-tint-text: 58%;
  /* Alias de tokens que ya existían con otro nombre. Se resuelven en \`<html>\`, así que siguen al tema. */
  --dylo-border: var(--dylo-line);
  --dylo-text-dim: var(--dylo-muted);
  --dylo-bg: var(--dylo-page-bg);
}

/* ===== Semánticos — DARK ===== */
/* Aplica cuando el usuario elige dark explícitamente... */
[data-theme='dark'] {
  --dylo-page-bg: #0f0f0f;
  --dylo-login-bg: #141414;
  --dylo-surface: #1e1e1e;
  --dylo-surface-border: #484848;
  --dylo-ink: #ffffff;
  --dylo-text: #d6d8dc;
  --dylo-muted: #9a9fa8;
  --dylo-line: #333333;
  --dylo-field-bg: #2a2a2a;
  --dylo-field-border: #3a3a3a;
  --dylo-field-icon: #9a9fa8;
  --dylo-footer: rgba(255, 255, 255, 0.45);
  --dylo-danger: #ff6b6b;
  --dylo-danger-bg: rgba(229, 72, 77, 0.16);
  --shadow-card: 0 4px 16px rgba(0, 0, 0, 0.32);
  --dylo-sidebar-border: var(--dylo-orange);
  --dylo-card-border-width: 2px;
  --dylo-collapse-icon: var(--dylo-orange);
  --dylo-spotlight-bg: #4d4d4d;
  --dylo-spotlight-border: #5e5e5e;
  --dylo-spotlight-text: #ffffff;
  --dylo-warning: #e0a44a;
  --dylo-surface-2: #2a2a2a;
  --dylo-tint-text: 85%;
}

/* ...o cuando el sistema está en dark y NO hay preferencia explícita. */
@media (prefers-color-scheme: dark) {
  :root:not([data-theme='light']):not([data-theme='dark']) {
    --dylo-page-bg: #0f0f0f;
    --dylo-login-bg: #141414;
    --dylo-surface: #1e1e1e;
    --dylo-surface-border: #484848;
    --dylo-ink: #ffffff;
    --dylo-text: #d6d8dc;
    --dylo-muted: #9a9fa8;
    --dylo-line: #333333;
    --dylo-field-bg: #2a2a2a;
    --dylo-field-border: #3a3a3a;
    --dylo-field-icon: #9a9fa8;
    --dylo-footer: rgba(255, 255, 255, 0.45);
    --dylo-danger: #ff6b6b;
    --dylo-danger-bg: rgba(229, 72, 77, 0.16);
    --shadow-card: 0 4px 16px rgba(0, 0, 0, 0.32);
    --dylo-sidebar-border: var(--dylo-orange);
    --dylo-card-border-width: 2px;
    --dylo-collapse-icon: var(--dylo-orange);
    --dylo-spotlight-bg: #4d4d4d;
    --dylo-spotlight-border: #5e5e5e;
    --dylo-spotlight-text: #ffffff;
    --dylo-warning: #e0a44a;
    --dylo-surface-2: #2a2a2a;
    --dylo-tint-text: 85%;
  }
}

/* ===== Animaciones globales V2 ===== */
:root {
  --dylo-sk-base: #dce1e7;
  --dylo-sk-hi: #f3f5f8;
  --dylo-sk-wave: rgba(255, 255, 255, 0.95);
}
[data-theme='dark'] {
  --dylo-sk-base: #232323;
  --dylo-sk-hi: #343434;
  --dylo-sk-wave: rgba(255, 255, 255, 0.09);
  --dtp-icon-filter: invert(0.85);
}
@media (prefers-color-scheme: dark) {
  :root:not([data-theme='light']):not([data-theme='dark']) {
    --dylo-sk-base: #232323;
    --dylo-sk-hi: #343434;
    --dylo-sk-wave: rgba(255, 255, 255, 0.09);
    --dtp-icon-filter: invert(0.85);
  }
}

@keyframes dylo-fade-up {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes dylo-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes dylo-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
@keyframes dylo-wave {
  0% { transform: translateX(-160%); }
  100% { transform: translateX(220%); }
}
@keyframes dylo-dropdown {
  from { opacity: 0; transform: translateY(-6px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes dylo-pop {
  0% { opacity: 0; transform: scale(0.96); }
  100% { opacity: 1; transform: scale(1); }
}

/* Entrada suave para el contenido de las páginas */
.dylo-animate-in {
  animation: dylo-fade-up 0.35s ease both;
}

/* ===== Loading "barrido de luz" reutilizable (cards + inputs) ===== */
/* El host debe posicionar el overlay */
.dylo-loading-host {
  position: relative;
}
.dylo-loading-sweep {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  overflow: hidden;
  pointer-events: none;
  z-index: 6;
  animation: dylo-card-breathe 1.8s ease-in-out infinite;
}
.dylo-loading-sweep::after {
  content: '';
  position: absolute;
  top: -60%;
  left: -75%;
  width: 55%;
  height: 220%;
  background: linear-gradient(
    90deg,
    transparent,
    color-mix(in srgb, var(--dylo-teal-500) 26%, transparent),
    transparent
  );
  transform: rotate(16deg);
  animation: dylo-card-sweep 1.6s ease-in-out infinite;
}
/* Variante para campos pequeños (inputs / selects): barrido más rápido, pulso sutil */
.dylo-loading-sweep--field {
  animation-duration: 1.5s;
}
.dylo-loading-sweep--field::after {
  width: 45%;
  animation-duration: 1.25s;
}
@keyframes dylo-card-sweep {
  0% { left: -75%; opacity: 0; }
  15% { opacity: 1; }
  85% { opacity: 1; }
  100% { left: 155%; opacity: 0; }
}
@keyframes dylo-card-breathe {
  0%, 100% { box-shadow: inset 0 0 0 1.5px color-mix(in srgb, var(--dylo-teal-500) 14%, transparent); }
  50% { box-shadow: inset 0 0 0 1.5px color-mix(in srgb, var(--dylo-teal-500) 42%, transparent); }
}

/* Accesibilidad: sin movimiento si el usuario lo prefiere */
@media (prefers-reduced-motion: reduce) {
  .dylo-loading-sweep,
  .dylo-loading-sweep::after,
  .dylo-animate-in,
  *[class*='shimmer'],
  *[class*='Skeleton'],
  *[class*='skeleton'],
  *[class*='Skeleton']::after,
  *[class*='skeleton']::after {
    animation: none !important;
  }
  * {
    scroll-behavior: auto !important;
  }
}

/* =====================================================================
   El fondo del documento (21-oct-2026)
   =====================================================================
   > *"el header se queda blanco donde esta la hora aun en developers module ni darkmode"*

   🔑 **Safari 26 en iPhone ya no lee \`<meta name="theme-color">\`**: pinta la barra de estado (donde va la hora) con el
   \`background-color\` del \`<body>\` y, si no tiene, de blanco. El body no tenía fondo —el de la página lo pinta \`.shell\`—,
   así que la barra salía blanca en los dos temas y en Developer. Safari la vuelve a leer sola cuando el fondo cambia.

   📌 En pantalla no cambia nada: \`.shell\` y el login siguen pintando lo mismo encima. Solo cambian la barra del teléfono
   y el color del rebote al desplazar. Developer y el login ponen su propio fondo con una clase en el body (\`devTheme.css\`
   y \`Login.tsx\`), y \`theme/themeColor.ts\` copia el resultado al \`theme-color\` para Chrome en Android.

   ⚠️ El encabezado móvil (\`.mobileBar\`, fijo arriba) no le sirve a Safari para esto: Safari no toma un elemento fijo que
   lleve \`backdrop-filter\`. */
body {
  background-color: var(--dylo-page-bg);
}
body.dylo-login-shell {
  background-color: var(--dylo-login-bg);
}
`, "",{"version":3,"sources":["webpack://./src/v2/styles/tokens.css"],"names":[],"mappings":"AAEA;;;;;;;;;;;EAWE;;AAEF;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,gDAAgD;EAChD,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;;EAE7B;;;+CAG6C;EAC7C,uBAAuB;;EAEvB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;;EAEhB,kCAAkC;EAClC,kDAAkD;;EAElD,yBAAyB;EACzB,gFAAgF;;EAEhF,6CAA6C;EAC7C,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;EAC5B,0BAA0B;EAC1B,uCAAuC;EACvC,sBAAsB;EACtB,yBAAyB;EACzB,6CAA6C;;EAE7C,wCAAwC;EACxC,iDAAiD;EACjD,sDAAsD;EACtD,+BAA+B;EAC/B,6EAA6E;EAC7E,6BAA6B;EAC7B,mFAAmF;EACnF,4BAA4B;EAC5B,gCAAgC;EAChC,8BAA8B;;EAE9B;;;;;GAKC;EACD,wGAAwG;EACxG,uBAAuB;EACvB,yFAAyF;EACzF,yBAAyB;EACzB,4FAA4F;EAC5F,qBAAqB;EACrB,uGAAuG;EACvG,+BAA+B;EAC/B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC,0DAA0D;AAC1D;EACE,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;EAC5B,0BAA0B;EAC1B,wCAAwC;EACxC,sBAAsB;EACtB,yCAAyC;EACzC,6CAA6C;EAC7C,yCAAyC;EACzC,6BAA6B;EAC7B,wCAAwC;EACxC,4BAA4B;EAC5B,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,wEAAwE;AACxE;EACE;IACE,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,wBAAwB;IACxB,4BAA4B;IAC5B,0BAA0B;IAC1B,wCAAwC;IACxC,sBAAsB;IACtB,yCAAyC;IACzC,6CAA6C;IAC7C,yCAAyC;IACzC,6BAA6B;IAC7B,wCAAwC;IACxC,4BAA4B;IAC5B,gCAAgC;IAChC,8BAA8B;IAC9B,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;EACvB;AACF;;AAEA,wCAAwC;AACxC;EACE,uBAAuB;EACvB,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,yCAAyC;EACzC,+BAA+B;AACjC;AACA;EACE;IACE,uBAAuB;IACvB,qBAAqB;IACrB,yCAAyC;IACzC,+BAA+B;EACjC;AACF;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;AACA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;AACA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;AACA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;AACA;EACE,KAAK,UAAU,EAAE,sBAAsB,EAAE;EACzC,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA,mDAAmD;AACnD;EACE,uCAAuC;AACzC;;AAEA,uEAAuE;AACvE,uCAAuC;AACvC;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,sDAAsD;AACxD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,YAAY;EACZ;;;;;GAKC;EACD,wBAAwB;EACxB,oDAAoD;AACtD;AACA,sFAAsF;AACtF;EACE,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,KAAK,UAAU,EAAE,UAAU,EAAE;EAC7B,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE,UAAU,EAAE;AACjC;AACA;EACE,WAAW,uFAAuF,EAAE;EACpG,MAAM,uFAAuF,EAAE;AACjG;;AAEA,4DAA4D;AAC5D;EACE;;;;;;;;IAQE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;;;;;;;;;;;;;;6BAc6B;AAC7B;EACE,qCAAqC;AACvC;AACA;EACE,sCAAsC;AACxC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');\n\n/*\n * Design tokens del rediseño V2 de Dylo.\n *\n * - La PALETA DE MARCA (teal/azul/naranja) y las medidas (radios, fuente)\n *   son constantes: no cambian entre temas.\n * - Los TOKENS SEMÁNTICOS (superficies, texto, campos, sombras) se resuelven\n *   por tema mediante el atributo `data-theme` en <html>:\n *     · Sin atributo  -> sigue el tema del SISTEMA (prefers-color-scheme). [default]\n *     · data-theme=\"light\" / \"dark\" -> fuerza el tema elegido por el usuario.\n *\n * El ThemeProvider de V2 gestiona el atributo y la persistencia.\n */\n\n:root {\n  /* ---- Marca — teal ---- */\n  --dylo-teal-900: #00827e;\n  --dylo-teal-700: #008984;\n  --dylo-teal-500: #18a29c;\n  --dylo-teal-300: #33bdb7;\n\n  /* ---- Marca — azul ---- */\n  --dylo-blue-700: #005da0;\n  --dylo-blue-500: #009ce0;\n  --dylo-blue-300: #67c9f2;\n\n  /* ---- Acento — naranja (botón primario) ---- */\n  --dylo-orange: #f7941e;\n  --dylo-orange-hover: #e88510;\n  --dylo-orange-active: #d97a08;\n\n  /* ---- Éxito — verde de cierre ----\n     Mismo verde que ya usa el estatus \"Delivered\" en los catálogos de estatus\n     (`statusCatalogs.ts`), para que un embarque cerrado se lea igual en la tabla,\n     en la barra de avance y en el recorrido. */\n  --dylo-success: #22a04a;\n\n  /* ---- Radios ---- */\n  --radius-card: 24px;\n  --radius-control: 12px;\n  --radius-sm: 8px;\n\n  /* ---- Sombra de controles ---- */\n  --shadow-control: 0 1px 2px rgba(16, 24, 40, 0.05);\n\n  /* ---- Tipografía ---- */\n  --font-sans: 'Poppins', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;\n\n  /* ===== Semánticos — LIGHT (default) ===== */\n  --dylo-page-bg: #f4f6f8;\n  --dylo-login-bg: #2b2b2b;\n  --dylo-surface: #ffffff;\n  --dylo-surface-border: #dce0e6;\n  --dylo-ink: #222222;\n  --dylo-text: #3a3f45;\n  --dylo-muted: #8a8f98;\n  --dylo-line: #e4e7ec;\n  --dylo-field-bg: #ffffff;\n  --dylo-field-border: #e2e5ea;\n  --dylo-field-icon: #9aa0a8;\n  --dylo-footer: rgba(255, 255, 255, 0.6);\n  --dylo-danger: #e5484d;\n  --dylo-danger-bg: #fdecec;\n  --shadow-card: 0 4px 16px rgba(0, 0, 0, 0.08);\n\n  /* Borde del sidebar (naranja en dark) */\n  --dylo-sidebar-border: var(--dylo-surface-border);\n  /* Grosor de borde de las cards (más grueso en dark) */\n  --dylo-card-border-width: 1.5px;\n  /* Color del chevron del botón de colapsar (blanco en light, ámbar en dark) */\n  --dylo-collapse-icon: #ffffff;\n  /* Card \"spotlight\" (Client Analysis): oscura en light, superficie normal en dark */\n  --dylo-spotlight-bg: #111214;\n  --dylo-spotlight-border: #1e1f22;\n  --dylo-spotlight-text: #e9eaec;\n\n  /*\n    🔴 15-oct-2026: tokens que varios módulos usaban SIN que existieran. Un `var()` sin respaldo que apunta a un\n    token inexistente no falla: el navegador descarta la declaración y el texto hereda el color de su padre. Así\n    salía \"Assigned\" en negro en la campanita, y las tarjetas de la bandeja no tenían borde ni barra de acento.\n    `styles/tokens.test.ts` falla si vuelve a pasar.\n  */\n  /* Advertencia: ámbar. Más oscuro en claro, para que el texto sobre su tinte se lea (contraste 4.5:1). */\n  --dylo-warning: #b45309;\n  /* Superficie secundaria: pastillas neutras, etiquetas de modalidad, botones de filtro. */\n  --dylo-surface-2: #f1f3f6;\n  /* Cuánto del color de un estatus o un área entra en su texto; el resto es tinta del tema. */\n  --dylo-tint-text: 58%;\n  /* Alias de tokens que ya existían con otro nombre. Se resuelven en `<html>`, así que siguen al tema. */\n  --dylo-border: var(--dylo-line);\n  --dylo-text-dim: var(--dylo-muted);\n  --dylo-bg: var(--dylo-page-bg);\n}\n\n/* ===== Semánticos — DARK ===== */\n/* Aplica cuando el usuario elige dark explícitamente... */\n[data-theme='dark'] {\n  --dylo-page-bg: #0f0f0f;\n  --dylo-login-bg: #141414;\n  --dylo-surface: #1e1e1e;\n  --dylo-surface-border: #484848;\n  --dylo-ink: #ffffff;\n  --dylo-text: #d6d8dc;\n  --dylo-muted: #9a9fa8;\n  --dylo-line: #333333;\n  --dylo-field-bg: #2a2a2a;\n  --dylo-field-border: #3a3a3a;\n  --dylo-field-icon: #9a9fa8;\n  --dylo-footer: rgba(255, 255, 255, 0.45);\n  --dylo-danger: #ff6b6b;\n  --dylo-danger-bg: rgba(229, 72, 77, 0.16);\n  --shadow-card: 0 4px 16px rgba(0, 0, 0, 0.32);\n  --dylo-sidebar-border: var(--dylo-orange);\n  --dylo-card-border-width: 2px;\n  --dylo-collapse-icon: var(--dylo-orange);\n  --dylo-spotlight-bg: #4d4d4d;\n  --dylo-spotlight-border: #5e5e5e;\n  --dylo-spotlight-text: #ffffff;\n  --dylo-warning: #e0a44a;\n  --dylo-surface-2: #2a2a2a;\n  --dylo-tint-text: 85%;\n}\n\n/* ...o cuando el sistema está en dark y NO hay preferencia explícita. */\n@media (prefers-color-scheme: dark) {\n  :root:not([data-theme='light']):not([data-theme='dark']) {\n    --dylo-page-bg: #0f0f0f;\n    --dylo-login-bg: #141414;\n    --dylo-surface: #1e1e1e;\n    --dylo-surface-border: #484848;\n    --dylo-ink: #ffffff;\n    --dylo-text: #d6d8dc;\n    --dylo-muted: #9a9fa8;\n    --dylo-line: #333333;\n    --dylo-field-bg: #2a2a2a;\n    --dylo-field-border: #3a3a3a;\n    --dylo-field-icon: #9a9fa8;\n    --dylo-footer: rgba(255, 255, 255, 0.45);\n    --dylo-danger: #ff6b6b;\n    --dylo-danger-bg: rgba(229, 72, 77, 0.16);\n    --shadow-card: 0 4px 16px rgba(0, 0, 0, 0.32);\n    --dylo-sidebar-border: var(--dylo-orange);\n    --dylo-card-border-width: 2px;\n    --dylo-collapse-icon: var(--dylo-orange);\n    --dylo-spotlight-bg: #4d4d4d;\n    --dylo-spotlight-border: #5e5e5e;\n    --dylo-spotlight-text: #ffffff;\n    --dylo-warning: #e0a44a;\n    --dylo-surface-2: #2a2a2a;\n    --dylo-tint-text: 85%;\n  }\n}\n\n/* ===== Animaciones globales V2 ===== */\n:root {\n  --dylo-sk-base: #dce1e7;\n  --dylo-sk-hi: #f3f5f8;\n  --dylo-sk-wave: rgba(255, 255, 255, 0.95);\n}\n[data-theme='dark'] {\n  --dylo-sk-base: #232323;\n  --dylo-sk-hi: #343434;\n  --dylo-sk-wave: rgba(255, 255, 255, 0.09);\n  --dtp-icon-filter: invert(0.85);\n}\n@media (prefers-color-scheme: dark) {\n  :root:not([data-theme='light']):not([data-theme='dark']) {\n    --dylo-sk-base: #232323;\n    --dylo-sk-hi: #343434;\n    --dylo-sk-wave: rgba(255, 255, 255, 0.09);\n    --dtp-icon-filter: invert(0.85);\n  }\n}\n\n@keyframes dylo-fade-up {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n@keyframes dylo-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n@keyframes dylo-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n@keyframes dylo-wave {\n  0% { transform: translateX(-160%); }\n  100% { transform: translateX(220%); }\n}\n@keyframes dylo-dropdown {\n  from { opacity: 0; transform: translateY(-6px) scale(0.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n@keyframes dylo-pop {\n  0% { opacity: 0; transform: scale(0.96); }\n  100% { opacity: 1; transform: scale(1); }\n}\n\n/* Entrada suave para el contenido de las páginas */\n.dylo-animate-in {\n  animation: dylo-fade-up 0.35s ease both;\n}\n\n/* ===== Loading \"barrido de luz\" reutilizable (cards + inputs) ===== */\n/* El host debe posicionar el overlay */\n.dylo-loading-host {\n  position: relative;\n}\n.dylo-loading-sweep {\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 6;\n  animation: dylo-card-breathe 1.8s ease-in-out infinite;\n}\n.dylo-loading-sweep::after {\n  content: '';\n  position: absolute;\n  top: -60%;\n  left: -75%;\n  width: 55%;\n  height: 220%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    color-mix(in srgb, var(--dylo-teal-500) 26%, transparent),\n    transparent\n  );\n  transform: rotate(16deg);\n  animation: dylo-card-sweep 1.6s ease-in-out infinite;\n}\n/* Variante para campos pequeños (inputs / selects): barrido más rápido, pulso sutil */\n.dylo-loading-sweep--field {\n  animation-duration: 1.5s;\n}\n.dylo-loading-sweep--field::after {\n  width: 45%;\n  animation-duration: 1.25s;\n}\n@keyframes dylo-card-sweep {\n  0% { left: -75%; opacity: 0; }\n  15% { opacity: 1; }\n  85% { opacity: 1; }\n  100% { left: 155%; opacity: 0; }\n}\n@keyframes dylo-card-breathe {\n  0%, 100% { box-shadow: inset 0 0 0 1.5px color-mix(in srgb, var(--dylo-teal-500) 14%, transparent); }\n  50% { box-shadow: inset 0 0 0 1.5px color-mix(in srgb, var(--dylo-teal-500) 42%, transparent); }\n}\n\n/* Accesibilidad: sin movimiento si el usuario lo prefiere */\n@media (prefers-reduced-motion: reduce) {\n  .dylo-loading-sweep,\n  .dylo-loading-sweep::after,\n  .dylo-animate-in,\n  *[class*='shimmer'],\n  *[class*='Skeleton'],\n  *[class*='skeleton'],\n  *[class*='Skeleton']::after,\n  *[class*='skeleton']::after {\n    animation: none !important;\n  }\n  * {\n    scroll-behavior: auto !important;\n  }\n}\n\n/* =====================================================================\n   El fondo del documento (21-oct-2026)\n   =====================================================================\n   > *\"el header se queda blanco donde esta la hora aun en developers module ni darkmode\"*\n\n   🔑 **Safari 26 en iPhone ya no lee `<meta name=\"theme-color\">`**: pinta la barra de estado (donde va la hora) con el\n   `background-color` del `<body>` y, si no tiene, de blanco. El body no tenía fondo —el de la página lo pinta `.shell`—,\n   así que la barra salía blanca en los dos temas y en Developer. Safari la vuelve a leer sola cuando el fondo cambia.\n\n   📌 En pantalla no cambia nada: `.shell` y el login siguen pintando lo mismo encima. Solo cambian la barra del teléfono\n   y el color del rebote al desplazar. Developer y el login ponen su propio fondo con una clase en el body (`devTheme.css`\n   y `Login.tsx`), y `theme/themeColor.ts` copia el resultado al `theme-color` para Chrome en Android.\n\n   ⚠️ El encabezado móvil (`.mobileBar`, fijo arriba) no le sirve a Safari para esto: Safari no toma un elemento fijo que\n   lleve `backdrop-filter`. */\nbody {\n  background-color: var(--dylo-page-bg);\n}\nbody.dylo-login-shell {\n  background-color: var(--dylo-login-bg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
